import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BotonTipo } from '../../../../components/boton/boton';
import { MatDialog } from '@angular/material';
import { CrearEntidadResponsableDialog } from './crear-entidad-responsable-dialog/crear-entidad-responsable-dialog.component';

@Component({
  selector: 'app-crear-entidad-responsable',
  templateUrl: './crear-entidad-responsable.component.html',
  styleUrls: ['./crear-entidad-responsable.component.scss']
})
export class CrearEntidadResponsableComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';
  @Input() IdEntidad: number | string;
  @Output() onCerrado = new EventEmitter();

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
  }

  openDialog(): void {
    let dialogCrear = this.dialog.open(CrearEntidadResponsableDialog, {
      disableClose: true,
      data: {
        IdEntidad: this.IdEntidad
      }
    });

    dialogCrear.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }
}
